import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'store';
import moment from 'moment';
import FeedImageSlider from 'components/community/components/feed/FeedImageSlider';
import LocalStitchMap from 'components/common/LocalStitchMap';
import { useRouter } from 'next/router';

var SpaceFeedDetailService = function SpaceFeedDetailService() {
  var feed = useSelector(function (state) {
    return state.community.branch_post;
  });
  var branch = feed.branch;
  var DATE_FORMAT = 'YYYY.MM.DD hh:mm';
  var router = useRouter();
  var mapCenter = {
    lat: Number(branch.latitude),
    lng: Number(branch.longitude)
  };

  var clickBranch = function clickBranch() {
    router.push("/branch/place/".concat(branch.id));
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "cnts-wrap",
    children: [/*#__PURE__*/_jsx("div", {
      className: "s-menu",
      children: /*#__PURE__*/_jsx("ul", {
        children: /*#__PURE__*/_jsx("li", {
          className: "selected",
          children: /*#__PURE__*/_jsx("a", {
            children: branch.region.name
          })
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "activity-list feed-detail",
      children: [/*#__PURE__*/_jsx("div", {
        className: "spot-info noline",
        children: /*#__PURE__*/_jsxs("div", {
          className: "hgroup",
          children: [/*#__PURE__*/_jsx("h3", {
            onClick: clickBranch,
            style: {
              cursor: 'pointer'
            },
            children: branch.name
          }), /*#__PURE__*/_jsx("p", {
            children: moment(feed.created_at).format(DATE_FORMAT)
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "photo-w",
        children: /*#__PURE__*/_jsx(FeedImageSlider, {
          images: feed.images
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "guide-detail",
        children: /*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: {
            __html: feed.content
          }
        })
      }), /*#__PURE__*/_jsx(LocalStitchMap, {
        center: mapCenter,
        zoom: 15,
        branches: [branch],
        height: "30vh"
      })]
    })]
  });
};

export default SpaceFeedDetailService;